import { FormTextareaField, lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { CurrencyInputFieldWrapper } from '../../../CurrencyInputFieldWrapper';
import { CashierCloseShiftKeys } from './formMapping';

interface Params {
    enabledCurrencies: string[];
}

export const CashierCloseShiftFormContent = ({ enabledCurrencies }: Params) => {
    return (
        <Stack distribution="stretch" vertical spacing="300">
            {enabledCurrencies.sort().map((currencyCode) => {
                return (
                    <CurrencyInputFieldWrapper
                        key={currencyCode}
                        currencyCode={currencyCode}
                        label={currencyCode}
                        name={`${CashierCloseShiftKeys.Currencies}.${currencyCode}`}
                    />
                );
            })}
            <FormTextareaField label={lt('Notes')} name={CashierCloseShiftKeys.Notes} size="medium" />
        </Stack>
    );
};
